
import React, {useState, useRef, useEffect} from 'react'
// import { Link } from 'react-router-dom'
import axios from "axios"
import { useSelector, useDispatch } from "react-redux";
import { set_page_refresh } from '../../redux/action';
import ImageWithBasePath, { uploadImageNew} from "../../img/imagewithbasebath"
import Spinner from '../../../feature-module/loader/spinner';
import { bucketObj } from "../../../environment";
import imageCompression from 'browser-image-compression'; 


const AddBrand = () => {
    const dispatch = useDispatch();
    const [brand, setBrand] = useState({})
    const [imageLoading, setImageLoading] = useState(0)
    const [imageData, setImageData] = useState({})
    const brandData = useSelector((state) => state.brand_edit);
    const closeRef = useRef(null);
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    
    useEffect(() => {
        console.log("brandData", brandData)
        let cData = JSON.parse(JSON.stringify(brandData || {}))
        if(!cData?.name) {
            setBrand({name: ""})
            setImageData({})
            return;
        }
        if(cData.images && typeof cData.images == "string") {
            cData.images = JSON.parse(cData.images)
        }
        setBrand(cData)
          // Clear imageData when brandData is updated
        setImageData({});
    }, [brandData])

    const submit= async (event) => {
        event.preventDefault()
        event.stopPropagation()
        const form = event.currentTarget;
        console.log()
        try {
          if(form?.checkValidity()) {
    
            let res = await axios.post('addbrand/', brand)
            console.log(res)
            closeRef.current?.click()
            document.querySelector(".modal-backdrop").classList.toggle("show")
            dispatch(set_page_refresh("brandlist"))
            // return true;
          }
        } catch(e) {
          console.log(e)
          return true;
        }
        
    
        return true;
      }
    const handleInputChange = (e) => {
    console.log(e)
    const { name, value } = e.target;
    setBrand(prevState => ({
        ...prevState,
        [name]: value
    }));
    };
 
    async function handleFileUpload(event) {
        try {
            if(event.target.files.length) {
            const file = event.target.files[0];
            // Check the file size
            if (file.size > 5242880) {//5mb
                alert(t?.[l]?.["file_size_exceeds_5_mb_limit"] || "File size exceeds 3 MB limit");
                event.target.value = ''; // Clear the file input
                return;
            }
            // Image compression options
            const options = {
                maxSizeMB: 1, // Adjust the max size as needed
                maxWidthOrHeight: 500, // Adjust dimensions as needed
                useWebWorker: true
            };
            const compressedFile = await imageCompression(file, options);
            let name = await uploadImageNew(compressedFile,'brand','img');

            event.target.value = '';
        
            let imgs = JSON.parse(JSON.stringify(brand?.images || []));
            imgs.push(name);
            setBrand(prevState => ({
                ...prevState,
                ["images"]: [name]
            }));

            }
        } catch (error) {
            console.error('Error compressing image:', error);
        }
    }
   
    useEffect(() => {
        async function fetchImages() {
      
        if(brand.images) {
            setImageLoading(1)
            setImageData(brand.images)
            setImageLoading(0)
          }
        }
        fetchImages()
    }, [brand])
    return (
        <>
            {/* Add Brand */}
            <div className="modal fade" id="add-brand">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>{Object.keys(brandData || {}).length ? t?.[l]?.["edit_brand"] || "Edit Brand" : t?.[l]?.["create_brand"] || "Create Brand"}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body new-employee-field">
                                    <form onSubmit={submit}>
                                        <div className="mb-3">
                                            <label className="form-label">{t?.[l]?.["brand"] || "Brand"}</label>
                                            <input type="text" className="form-control" value={brand?.name || ""} required name="name" onChange={handleInputChange} />
                                        </div>
                                        <div className="profile-pic-upload mb-3">
                                            <div className={`profile-pic brand-pic ${Object.keys(imageData).length ? "" : "hidden"}}`}>
                                                {imageData && imageData.length > 0 && imageData.map((key) => {
                                                    // if(imageData[key]) {
                                                    return <div className="phone-img" style={{padding: "5px"}} key={key}>
                                                        <ImageWithBasePath
                                                        src={bucketObj.bucketUrl+bucketObj.objectKey+key}
                                                        alt={key}
                                                        absolutePath="true"
                                                        />
                                                        {/* <Link to="#">
                                                        <X
                                                            className="x-square-add remove-product"
                                                            onClick={() => {handleRemoveProduct(key, index)}}
                                                        />
                                                        </Link> */}
                                                    </div>
                                                    // } else {
                                                    //   return <></>
                                                    // }
                                                })}
                                            </div>
                                            <div className="image-upload mb-0">
                                                <input type="file" onChange={handleFileUpload} 
                                            accept="image/png,image/jpg,image/gif,image/jpeg,image/svg"/>
                                                <div className="image-uploads" style={{cursor: "pointer"}}>
                                                    <h4>{Object.keys(imageData).length ? t?.[l]?.["change_image"] : t?.[l]?.["add_image"]}</h4>
                                                </div>
                                            </div>
                                            {imageLoading > 0 && <Spinner />}
                                        </div>
                                        
                                        <div className="mb-0 hidden">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">Status</span>
                                                <input
                                                    type="checkbox"
                                                    id="user2"
                                                    className="check"
                                                    defaultChecked="true"
                                                />
                                                <label htmlFor="user2" className="checktoggle" />
                                            </div>
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                ref={closeRef} 
                                            >
                                                {t?.[l]?.["cancel"] || "Cancel"}
                                            </button>
                                            <button  type="submit" className="btn btn-submit">
                                                {t?.[l]?.["save"] || "Save"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Brand */}
        </>

    )
}

export default AddBrand
